(function () {
    'use strict';

    run.superadmin.parts.confirmTriggeredAction = function() {
        $(document).ready(function() {
            $(document).on("click", ".trigger_confirm", function(e) {
                var _id = $(this).data('id');
                var _location = $(this).data('href');
                var _action = $(this).data('action');
                var _email = $(this).data('email');
                var _message = $(this).data('message');
                var _callback = $(this).data('callback');

                let cancelButtonClass = 'btn-light';
                let confirmButtonClass = 'btn-success';
                let confirmButtonText = (e.target.hasAttribute('data-confirm-button-text')) ? e.target.dataset.confirmButtonText : translations.confirmAlerts.actionButtonConfirm;
                const confirmType = (e.target.hasAttribute('data-confirm-type')) ? e.target.dataset.confirmType : 'default';
                //console.log(e.target);

                switch (confirmType) {
                    case 'delete':
                        cancelButtonClass = 'btn-light';
                        confirmButtonClass = 'btn-danger';
                    break;
                    case 'default':
                    default:
                        cancelButtonClass = 'btn-light';
                        confirmButtonClass = 'btn-success';
                    break;
                }

                //let html = `<p>Action: <strong>`+_action+`</strong></p>`;
                let html = `<p>`+_action+`</p>`;
                if (_email) {
                    html += `<p>Email: <strong>`+_email+`</strong></p>`;
                }
                if (_id) {
                    html += `<p>ID: `+_id+`</p>`;
                }
                if (_message) {
                    html += `<p>`+_message+`</p>`;
                }

                Swal.fire({
                    title: translations.confirmAlerts.actionTitle,
                    html: html,
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    focusCancel: true,
                    cancelButtonText: translations.confirmAlerts.actionButtonCancel,
                    confirmButtonText: confirmButtonText,
                    buttonsStyling: false,
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn btn-lg ' + cancelButtonClass,
                        confirmButton: 'btn btn-lg ms-4 ' + confirmButtonClass
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                    if (result.value) {
                        if (_callback) {
                            window["_callback"];
                            return;
                        }

                        window.location.href = _location;
                    }
                });
            });

            // Batch actions
            $('#batch_proceed').on('click',function(e){
                e.preventDefault();
                var form = $(this).parents('form');
                var _action = $("#batch_action").val();

                Swal.fire({
                    title: translations.confirmAlerts.actionTitle,
                    html: `
                        <p>`+translations.confirmAlerts.action+` <strong>`+_action+`</strong></p>
                    `,
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: true,
                    focusCancel: true,
                    cancelButtonText: translations.confirmAlerts.actionButtonCancel,
                    confirmButtonText: translations.confirmAlerts.actionButtonConfirm,
                    buttonsStyling: false,
                    reverseButtons: true,
                    customClass: {
                        cancelButton: 'btn btn-lg btn-light',
                        confirmButton: 'btn btn-lg btn-primary ms-4'
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                    if (result.value) {
                        form.submit();
                    }
                });
            });
        });
    };
})();